export const waitFor = (millSeconds) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, millSeconds)
  })
}

export const retryPromiseWithDelay = async (promise, nthTry, delayTime) => {
  try {
    const res = await promise;
    return res;
  } catch (e) {
    if (nthTry === 1) {
      return Promise.reject(e);
    }
    console.log('retrying', nthTry, 'time');
    // wait for delayTime amount of time before calling this method again
    await waitFor(delayTime);
    return retryPromiseWithDelay(promise, nthTry - 1, delayTime);
  }
}
